module.exports = __webpack_public_path__ + "img/2.27e37ea6.jpg";